"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.noCredits.message': 'You have insufficient credits to use the chat service. Please purchase more credits to continue.',
};
